import React from 'react'
import { AccordionSummary, Fab } from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import { useLocale } from 'src/locales/useLocale'

export const EmbroideryAccordionSummary: React.FC<{ embroideryIndex: number }> = ({ embroideryIndex }) => {
  const { t } = useLocale()
  return (
    <AccordionSummary
      expandIcon={
        <Fab size="small" tabIndex={-1} style={{ boxShadow: 'unset' }}>
          <ExpandLessIcon />
        </Fab>
      }
    >
      {`${t.EMBROIDERY_SETTING} ${embroideryIndex + 1}`}
    </AccordionSummary>
  )
}
